const default_project_menu = [
   {
      name: 'general.projects.project_settings.title',
      link: '/project_settings',
      icon: 'fa fa-cog',
      requiresPermissions: [
                           'project_settings',
                           ]
   },
   {
      name: 'general.projects.progress_settings.title',
      link: '/progress_settings',
      icon: 'fa fa-sliders',
      requiresPermissions: [
                           'project_progress_settings',
                           ]
   },
   {
      name:'general.construction.progress_reporting.title',
      link:'/project_progress_reporting',
      icon:'fa fa-tasks',
      requiresPermissions: [
                           'project_progress_reporting',
                           ]
   },
   {
      name:'general.projects.progress.title',
      icon:'fa fa-percent',
      requiresPermissions: [
                           'project_progress_piping_value',
                           'project_progress_piping_weight',
                           'project_progress_welding',
                           'project_progress_bw_welding',
                           'project_progress_other_discipline_equipment',
                           'project_progress_other_discipline_ei',
                           'project_progress_other_discipline_steel',
                           'project_progress_other_discipline_civil',
                           'project_progress_other_discipline_painting',
                           'project_progress_other_discipline_insulation',
                           'project_progress_calculation_piping',
                           'project_progress_calculation_steel',
                           'project_progress_calculation_equipment',
                           'project_progress_calculation_civil',
                           'project_progress_calculation_ei',
                           'project_progress_calculation_other',
                           ],
      child:[
         {
            name: 'general.projects.progress.piping_value.title',
            link: '/progress/piping_value',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_progress_piping_value',
                                 ]
         },
         {
            name: 'general.projects.progress.piping_weight.title',
            link: '/progress/piping_weight',
            icon: 'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_progress_piping_weight',
                                 ]
         },
         {
            name: 'general.projects.progress.progress_welding.title',
            link: '/progress/welding',
            icon: 'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_progress_welding',
                                 ]
         },
         {
            name: 'general.projects.progress.progress_bw_welding.title',
            link: '/progress/bw_welding',
            icon: 'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_progress_bw_welding',
                                 ]
         },
         {
            name: 'general.projects.progress.other_discipline.title',
            icon: 'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_progress_other_discipline_equipment',
                                 'project_progress_other_discipline_ei',
                                 'project_progress_other_discipline_steel',
                                 'project_progress_other_discipline_civil',
                                 'project_progress_other_discipline_painting',
                                 'project_progress_other_discipline_insulation',
                                 ],
            child: [
               {
                  name: 'general.projects.progress.other_discipline.equipment.title',
                  link: '/progress/other_discipline/equipment',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_progress_other_discipline_equipment',
                                       ]
               },
               {
                  name: 'general.projects.progress.other_discipline.ei.title',
                  link: '/progress/other_discipline/ei',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_progress_other_discipline_ei',
                                       ]
               },
               {
                  name: 'general.projects.progress.other_discipline.steelstructure.title',
                  link: '/progress/other_discipline/steelstructure',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_progress_other_discipline_steelstructure',
                                       ]
               },
               {
                  name: 'general.projects.progress.other_discipline.civil.title',
                  link: '/progress/other_discipline/civil',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_progress_other_discipline_civil',
                                       ]
               },
               {
                  name: 'general.projects.progress.other_discipline.painting.title',
                  link: '/progress/other_discipline/painting',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_progress_other_discipline_painting',
                                       ]
               },
               {
                  name: 'general.projects.progress.other_discipline.insulation.title',
                  link: '/progress/other_discipline/insulation',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_progress_other_discipline_insulation',
                                       ]
               },
            ]
         },
         {
            name: 'general.projects.progress.calculation.title',
            icon: 'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_progress_calculation_piping',
                                 'project_progress_calculation_steel',
                                 'project_progress_calculation_equipment',
                                 'project_progress_calculation_civil',
                                 'project_progress_calculation_ei',
                                 'project_progress_calculation_other',
                                 ],
            child: [
               {
                  name: 'general.projects.progress.calculation.progress_calculation_piping.title',
                  link: '/progress/calculation/piping',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_progress_calculation_piping',
                                       ]
               },
               {
                  name: 'general.projects.progress.calculation.progress_calculation_steel.title',
                  link: '/progress/calculation/steel',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_progress_calculation_steel',
                                       ]
               },
               {
                  name: 'general.projects.progress.calculation.progress_calculation_equipment.title',
                  link: '/progress/calculation/equipment',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_progress_calculation_equipment',
                                       ]
               },
               {
                  name: 'general.projects.progress.calculation.progress_calculation_civil.title',
                  link: '/progress/calculation/civil',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_progress_calculation_civil',
                                       ]
               },
               {
                  name: 'general.projects.progress.calculation.progress_calculation_ei.title',
                  link: '/progress/calculation/ei',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_progress_calculation_ei',
                                       ]
               },
               {
                  name: 'general.projects.progress.calculation.progress_calculation_other.title',
                  link: '/progress/calculation/other',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_progress_calculation_other',
                                       ]
               }
            ]
         }
      ]
   },
   {
      name: 'general.projects.milestones.title',
      link: '/milestones',
      icon: 'fa fa-hourglass-end',
      requiresPermissions: [
                           'project_milestones',
                           ]
   },
   {
      name:'general.teams.title',
      link:'/teams',
      icon:'fas fa-user-friends',
      requiresPermissions: [
                           'project_teams',
                           ]
   },
   {
      name:'general.disciplines.title',
      link:'/disciplines',
      icon:'fa fa-list-ul',
      requiresPermissions: [
                           'project_disciplines',
                           ]
   },
   {
      name:'general.line_list.title',
      link:'/line_list',
      icon:'fa fa-minus-square',
      requiresPermissions: [
                           'project_line',
                           ]
   },

   {
      name:'general.isometric_management.title',
      link:'/isometric_management',
      icon:'fa fa-cube',
      requiresPermissions: [
                           'project_isometric',
                           ]
   },
   {
      name:'general.pressure_test_planning.title',
      link:'/pressure_test_planning',
      icon:'fa fa-fire',
      requiresPermissions: [
                           'project_pressure_test_planning',
                           ]
   },
   {
      name:'general.blinds_and_removed_items.title',
      link:'/blinds_and_removed_items',
      icon:'fa fa-circle',
      requiresPermissions: [
                           'project_blind',
                           'project_removed_item'
                           ]
   },
   {
      name:'general.welding.title',
      icon:'fa fa-chain-broken',
      requiresPermissions: [
                           'project_weld',
                           'project_weld_documentation',
                           'project_filler_material',
                           ],
      child:[
         {
            name:'general.welding.weld.title',
            link:'/welding/iso',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_weld',
                                 ]
         },
         {
            name:'general.welding.current_welds.title',
            link:'/welding/current_welds',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_current_welds',
                                 ]
         },
         {
            name:'general.welding.ndt_welds.title',
            link:'/welding/ndt_welds',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_ndt_welds',
                                 ]
         },
         {
            name:'general.welding.documentation.title',
            link:'/welding/documentation',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_weld_documentation',
                                 ]
         },
         {
            name:'general.welding.filler_material.title',
            link:'/welding/filler_material',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_filler_material',
                                 ]
         }
      ]
   },
   {
      name:'general.tie_in_management.title',
      link:'/tie_in_management',
      icon:'fa fa-sitemap',
      requiresPermissions: [
                           'project_tie_in',
                           ]
   },
   {
      name:'general.subcontractors.title',
      link:'/subcontractors',
      icon:'fa fa-user-circle',
      requiresPermissions: [
                           'project_subcontractors',
                           ]
   },
   {
      name:'general.construction.title',
      icon:'fa fa-file-text',
      requiresPermissions: [
                           'project_scaffolding',
                           'project_punch_list',
                           'project_spool_management',
                           'project_site_instructions',
                           'project_stock',
                           'project_material_requests',
                           ],
      child:[
         {
            name:'general.construction.scaffolding.title',
            link:'/construction/scaffolding',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_scaffolding',
                                 ]
         },
         {
            name:'general.construction.punch_list.title',
            link:'/construction/punch_list',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_punch_list',
                                 ]
         },
         {
            name:'general.construction.spool_management.title',
            link:'/construction/spool_management',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_spool_management',
                                 ]
         },
         {
            name:'general.construction.site_instructions.title',
            link:'/construction/site_instructions',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_site_instructions',
                                 ]
         },
         {
            name:'general.construction.painting.title',
            link:'/construction/painting',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_painting',
                                 ]
         },
         {
            name:'general.construction.material_management.title',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_stock',
                                 'project_material_requests',
                                 ],
             child:[
                  {
                     name:'general.construction.material_management.project_part.title',
                     link:'/construction/material_management/project_parts',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_stock',
                                          ]
                  },
                  {
                     name:'general.construction.material_management.isometric_request.title',
                     link:'/construction/material_management/isometric_material_requests',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_isometric_material_requests',
                                          ]
                  },
                  {
                     name:'general.construction.material_management.change_order_request.title',
                     link:'/construction/material_management/change_order_material_requests',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_change_order_material_requests',
                                          ]
                  },
             ]
         },
         {
            name:'general.construction.drawings.title',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_drawing_steel',
                                 'project_drawing_equipment',
                                 'project_drawing_civil',
                                 'project_drawing_ei',
                                 'project_drawing_other',
                                 ],
            child:[
               {
                  name:'general.construction.drawings.steel_drawings.title',
                  link:'/construction/drawings/steel_drawings',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_drawing_steel',
                                       ]
               },
               {
                  name:'general.construction.drawings.equipment_drawings.title',
                  link:'/construction/drawings/equipment_drawings',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_drawing_equipment',
                                       ]
               },
               {
                  name:'general.construction.drawings.civil_drawings.title',
                  link:'/construction/drawings/civil_drawings',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_drawing_civil',
                                       ]
               },
               {
                  name:'general.construction.drawings.ei_drawings.title',
                  link:'/construction/drawings/ei_drawings',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_drawing_ei',
                                       ]
               },
               {
                  name:'general.construction.drawings.other_drawings.title',
                  link:'/construction/drawings/other_drawings',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_drawing_other',
                                       ]
               }
            ]
         }
      ]
   },
   {
      name:'general.commercial.title',
      icon:'fa fa-file',
      requiresPermissions: [
                           'project_change_orders',
                           'project_calculation_overview_piping',
                           'project_calculation_overview_equipment',
                           'project_calculation_overview_painting',
                           'project_calculation_overview_scaffolding',
                           'project_calculation_overview_insulation',
                           'project_calculation_overview_steel',
                           'project_calculation_overview_civil',
                           'project_calculation_overview_ei',
                           'project_calculation_overview_other',
                           'project_calculation_overview_tie_in',
                           'project_calculation_overview_change_order',
                           ],
      child:[
         {
            name:'general.commercial.change_orders.title',
            link:'/commercial/change_orders',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_change_orders',
                                 ]
         },
         {
            name:'general.commercial.calculation.title',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_calculation_overview_piping',
                                 'project_calculation_overview_equipment',
                                 'project_calculation_overview_painting',
                                 'project_calculation_overview_scaffolding',
                                 'project_calculation_overview_insulation',
                                 'project_calculation_overview_steel',
                                 'project_calculation_overview_civil',
                                 'project_calculation_overview_ei',
                                 'project_calculation_overview_other',
                                 'project_calculation_overview_tie_in',
                                 'project_calculation_overview_change_order',
                                 ],
             child:[
                  {
                     name:'general.calculation.piping.title',
                     link:'/calculation/overview_piping',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_calculation_overview_piping',
                                          ]
                  },
                  {
                     name:'general.calculation.equipment.title',
                     link:'/calculation/overview_equipment',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_calculation_overview_equipment',
                                          ]
                  },
                  {
                     name:'general.calculation.painting.title',
                     link:'/calculation/overview_painting',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_calculation_overview_painting',
                                          ]
                  },
                  {
                     name:'general.calculation.scaffolding.title',
                     link:'/calculation/overview_scaffolding',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_calculation_overview_scaffolding',
                                          ]
                  },
                  {
                     name:'general.calculation.insulation.title',
                     link:'/calculation/overview_insulation',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_calculation_overview_insulation',
                                          ]
                  },
                  {
                     name:'general.calculation.steel_structure.title',
                     link:'/calculation/overview_steel_structure',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_calculation_overview_steel',
                                          ]
                  },
                  {
                     name:'general.calculation.civil_works.title',
                     link:'/calculation/overview_civil_works',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_calculation_overview_civil',
                                          ]
                  },
                  {
                     name:'general.calculation.ei_works.title',
                     link:'/calculation/overview_ei_works',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_calculation_overview_ei',
                                          ]
                  },
                  {
                     name:'general.calculation.other_works.title',
                     link:'/calculation/overview_other_works',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_calculation_overview_other',
                                          ]
                  },
                  {
                     name:'general.calculation.tie_in.title',
                     link:'/calculation/overview_tie_in',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_calculation_overview_tie_in',
                                          ]
                  },
                  {
                     name:'general.calculation.change_order.title',
                     link:'/calculation/overview_change_order',
                     icon:'fa fa-angle-double-right',
                     requiresPermissions: [
                                          'project_calculation_overview_change_order',
                                          ]
                  },
             ]
         },
      ]
   },
   {
      name:'general.administrative.title',
      icon:'fa fa-map-signs',
      requiresPermissions: [
                           'project_daily_log',
                           'project_hours_recording',
                           'project_delays',
                           'project_messages',
                           'project_task_manager',
                           'project_general_documents',
                           'project_storage',
                           ],
      child:[
         {
            name:'general.administrative.daily_logs.title',
            link:'/administrative/daily_logs',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_daily_log',
                                 ]
         },
         {
            name:'general.administrative.hours_recording.title',
            link:'/administrative/hours_recording',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_hours_recording',
                                 ]
         },
         {
            name:'general.administrative.delays.title',
            link:'/administrative/delays',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_delays',
                                 ]
         },
         {
            name:'general.administrative.messages.title',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_messages',
                                 ],
            child:[
               {
                  name:'general.administrative.messages.submittal.title',
                  link:'/administrative/messages/submittal',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_messages',
                                       ]
               },
               {
                  name:'general.administrative.messages.tq.title',
                  link:'/administrative/messages/tq',
                  icon:'fa fa-angle-double-right',
                  requiresPermissions: [
                                       'project_messages',
                                       ]
               }
            ]
         },
         {
            name:'general.administrative.task_manager.title',
            link:'/administrative/task_manager',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_task_manager',
                                 ]
         },
         {
            name:'general.administrative.general_documents.title',
            link:'/administrative/general_documents',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_general_documents',
                                 ]
         },
         {
            name:'general.administrative.storage.title',
            link:'/administrative/storage',
            icon:'fa fa-angle-double-right',
            requiresPermissions: [
                                 'project_storage',
                                 ]
         }
      ]
   },
   {
      name:'general.projects.calibrated_items.title',
      link:'/calibrated_items',
      icon:'fa fa-wrench',
      requiresPermissions: [
                           'project_calibrated_item',
                           ]
   },
];

export default default_project_menu;


// WEBPACK FOOTER //
// ./src/menu/project.js